import React from "react";
import "../style/sign.scss";
import { currentLocale } from "../locale";
const NavButtons = ({
  backDisabled,
  backOnClick,
  forwardDisabled,
  forwardOnClick,
  nextButton,
  loading,
  flashing
}) => {
  let className;
  if (loading) {
    className = "button-forward is-loading";
  } else if (flashing) {
    //className += " is-danger is-outlined"
    className = "button-pulse";
  } else {
    className = "button-forward";
  }
  return (
    <div className="level">
      <div className="titleBar has-background-white-ter">
        <button
          type="button"
          outlinedbutton="true" //outlinedbutton={value.toString()}
          //   outlinedbutton={true}
          className="button-back"
          disabled={backDisabled}
          onClick={backOnClick}
        >
          <i className="fas fa-step-backward" />
          &nbsp; {currentLocale.back}{" "}
        </button>
        <button
          type="button"
          className={className}
          disabled={forwardDisabled}
          onClick={forwardOnClick}
          // animation={flashForward.toString()}
          // flashforward={flashForward.toString()} //{flashForward}
          // flashforward="false"
        >
          {nextButton} &nbsp; <i className="fas fa-step-forward" />
        </button>
        <br />
      </div>
    </div>
  );
};

export default NavButtons;
